import request from 'Request'

const InvitesService = {
  async get({ code, inviteId }) {
    return request.get('/invites/get', { params: { code, id: inviteId } })
  },

  async list({ virtualOfficeId } = {}) {
    return request.post('/invites/list', { virtualOfficeId })
  },

  async create({ virtualOfficeId, maxUses, expiresOn, archived }) {
    return request.put('/invites/create', { virtualOfficeId, maxUses, expiresOn, archived })
  },

  async update({ code, inviteId, maxUses, expiresOn, archived }) {
    return request.patch('/invites/update', { code, id: inviteId, maxUses, expiresOn, archived })
  },

  async delete({ code, id }) {
    return request.delete('/invites/delete', {
      data: {
        code,
        id
      }
    })
  }
}

export default InvitesService
